export interface ICapabilitiesPrivileged {
  Name: string;
  Description: string;
}

// Keep in sync with the 'sofo.*' key strings in launchevent.js
export enum CustomPropertyKey {
  Archiving             = "sofo.archiving",
  ArchiveContactMissing = "sofo.archiveContactMissing",
  AppointmentSaved      = "sofo.appointmentSaved",
}

export enum RoamingSettingKey {
  // Name kept from the old Smart Alerts toggle: launchevent.js reads it, also the copy classic Outlook
  // keeps until it restarts. Never write false or remove it.
  SignedIn                    = "sofo.smartAlertsEnabled",
  ArchiveReminder             = "sofo.archiveReminder",
  ArchiveReminderNewEmails    = "sofo.archiveReminderNewEmails",
  ArchiveReminderReplies      = "sofo.archiveReminderReplies",
  ArchiveReminderForwards     = "sofo.archiveReminderForwards",
  ArchiveReminderExternalOnly = "sofo.archiveReminderExternalOnly",
  ReadAnnouncementIds         = "sofo.readAnnouncementIds",
  AppointmentSmartAlert       = "sofo.appointmentSmartAlertEnabled",
}

// Office.MailboxEnums.CategoryColor preset name for the "CategoryColor" roaming setting's fallback —
// shared so the settings page's displayed default and the color actually applied on archive can't drift apart.
export const DEFAULT_CATEGORY_COLOR = "Preset19"; // DarkGreen

export enum Capability {
  HugoAiGpt = "HugoAiGpt",
  HasSaleLicense = "HasSaleLicense",
  HasCsLicense = "HasCsLicense",
  SupportsPersonDetails = "SupportsPersonDetails",
  SupportsCreateOrphan = "SupportsCreateOrphan",
  SupportsContextualSalesAndProjectsForContact = "SupportsContextualSalesAndProjectsForContact",
  SupportsSavingProjectOnSale = "SupportsSavingProjectOnSale",
  SupportsArchivePreupload = "SupportsArchivePreupload",
}

// Must match FeatureKeys (Features/FeatureFlags/FeatureRegistry.cs) -
// nothing compiles the two together, so a rename on one side needs the other updated by hand.
export enum FeatureKey {
  AiSummary = "ai-summary",
  DefaultEmailType = "default-email-type",
  ArchiveComment = "archive-comment",
  ContactPrefillSuperOfficeAi = "contact-prefill-superoffice-ai",
}

export interface Announcement {
  id: string;
  date: string;
  title: string;
  message: string;
  learnMoreUrl?: string;
  // Shown when the user has any one of these Features enabled.
  requiredFeatures?: FeatureKey[];
  showSettingsIcon?: boolean;
  noteHeading?: string;
  note?: string;
  noteLinkText?: string;
  noteUrl?: string;
}

export interface ITicketMailBoxes {
  id: number;
  name: string;
  categoryName: string;
  priorityName: string;
}

export interface ITicketMessageMailBoxes {
  ticketId: number;
  title: string;
  categoryName: string;
  priorityName: string;
  ownerName: string;
  ticketUrl: string;
  contactName: string;
  personName: string;
}
